<template>
  <div>
    <div v-if="loadingUser" class="text-xs-center">
      <v-progress-circular
        indeterminate
        color="primary"
        small
        :width="4"
        class="my-4"
      ></v-progress-circular>
    </div>
    <template v-else>
      <template v-if="commentList && commentList.length > 0">
        <div
          v-for="(user, index) in commentList"
          @click="onSelectedComment(user)"
          :key="index"
          style="cursor: pointer"
        >
          <ReplyCommentUserItem v-model="commentList[index]"></ReplyCommentUserItem>
        </div>
      </template>
      <template v-else>
        <div class="text-xs-center mt-4 mb-4">
          <img src="/static/img/assets/livechat/no_user.png" alt />
          <div>No users</div>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import ReplyCommentUserItem from './ReplyCommentUserItem'

export default {
  props: ['value', 'loadingUser'],
  components: {
    ReplyCommentUserItem
  },
  data() {
    return {
      commentList: []
    }
  },
  mounted() {
    if (this.value) {
      this.commentList = this.value
    }
  },
  methods: {
    onSelectedComment(user) {
      this.$emit('onSelectedUser', user)
    }
  },
  watch: {
    value: function (newVal, oldVal) {
      this.commentList = newVal
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ticket/RabbitReplyFBPost/ReplyCommentUsers.vue